









import { inView, animate } from 'motion'
import { defineComponent, onMounted, ref, toRefs } from 'vue-demi'

import { defaultTo } from '@front/common/utils'

import { FADE_LEFT } from './animations'

export default defineComponent({
  props: {
    triggerOnScroll: {
      type: Boolean,
      default: false,
    },
    keyframes: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { triggerOnScroll, keyframes, options, isDisabled } = toRefs(props)

    const group = ref<HTMLElement>()

    async function triggerAnimation(container: HTMLElement) {
      if (!container || props.isDisabled) {
        return
      }
      const defaultVariant = FADE_LEFT
      const elements = Array.from(container.children)

      await animate(
        elements,
        defaultTo({ ...keyframes.value }, defaultVariant.keyframes),
        defaultTo({ ...options.value }, defaultVariant.options),
      ).finished

      emit('finished')
    }

    onMounted(() => {
      if (isDisabled.value || !group.value) {
        return
      }

      if (triggerOnScroll.value) {
        inView(
          group.value,
          () => {
            triggerAnimation(group.value)
          },
          {
            margin: '0px 0px -200px 0px',
          },
        )
        return
      }

      triggerAnimation(group.value)
    })

    return { group }
  },
})
